import { getSizeConfig } from '../../../../../dorian-shared/getSizeConfig';

const largeVideoPadding = 25;

export function useLargeVideoSize() {
  const { width } = getSizeConfig();
  return width - largeVideoPadding * 2;
}
